import React, { useEffect, Fragment } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import GetAppIcon from '@material-ui/icons/GetApp';
import ReceiptIcon from '@material-ui/icons/Receipt';
import PictureAsPdfSharpIcon from '@material-ui/icons/PictureAsPdfSharp';


import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';

import { DatePicker, KeyboardDateTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";

import DateFnsUtils from '@date-io/date-fns';
import Datetime from 'react-datetime'
import ReactLoading from 'react-loading';

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";

import DialogActions from "@material-ui/core/DialogActions";

import Slide from "@material-ui/core/Slide";

import { PDFViewer } from '@react-pdf/renderer'

import { Page, Text, View, Document, StyleSheet } from '@react-pdf/renderer';
import SearchIcon from '@material-ui/icons/Search';

import Select from '@material-ui/core/Select';

import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";


import GridContainer from "../components/Grid/GridContainer.js";
import GridItem from "../components/Grid/GridItem.js";

import TextField from '@material-ui/core/TextField';
import AutorenewIcon from '@material-ui/icons/Autorenew';
import { GridList } from '@material-ui/core';

import Accessioning from './Accessioning'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const columns =
  [{ id: 'invoice_no', label: 'Invoice ID' },
  { id: 'patient_name', label: 'Patient Name' },
  { id: "branch_name", label: "Branch" },
  { id: 'mobile_no', label: 'Mobile No' },
  { id: "date", label: "Date" },
  

  { id: 'remarks', label: 'Remarks' },
  { id: 'view', label: 'Action' }
  ]
function addZero(i) {
  if (i < 10) {
    i = "0" + i;
  }
  return i;
}
function to24Hours(d) {
  var h = addZero(d.getHours());
  var m = addZero(d.getMinutes());
  var s = addZero(d.getSeconds());
  return h + ":" + m + ":" + s;
}
const useStyles = makeStyles({
  root: {
    width: '100%',
  },
  container: {
    maxHeight: 1000,
  },
});
function msToTime(ms) {
  var seconds = (ms / 1000);
  var minutes = parseInt(seconds / 60, 10);
  seconds = seconds % 60;
  var hours = parseInt(minutes / 60, 10);
  minutes = minutes % 60;

  return addZero(hours) + ':' + addZero(minutes);
}

export default function AccessioningCallUp() {
  const classes = useStyles();
  var date = new Date()
  var temp_role = localStorage.getItem('role')
  date.setDate(date.getDate() - 1);


  const [selected, setSelected] = React.useState({
    reports: []
  })

  const [patient_invoice, setPatientInvoice] = React.useState(false)


  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [rows, setRows] = React.useState([]);
  const [org_rows, setOrg_Rows] = React.useState([]);
  const [loading, setLoading] = React.useState(false)
            {/* 25-nov-2025 all branches show in drop down option */}

  const [branches, setBranches] = React.useState([])
  const [branch, setBranch] = React.useState("")
  const [BranchName, setBranchName] = React.useState("")
  const [selectBranch, setSelectBranch] = React.useState([])


  const [invoice_no, setInvoiceNo] = React.useState("")

  const [to, setTo] = React.useState(new Date())
  var date_from = new Date()
  date_from.setDate(new Date().getDate() - 1)
  const [from, setFrom] = React.useState(date_from)
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const [OpenAccessioning, setOpenAccessioning] = React.useState(false)

  const [state, setState] = React.useState({
    status: 'All',
  });

  const handleChange = (event) => {
    const name = event.target.name;
    setState({
      ...state,
      [name]: event.target.value,
    });
  };
  const BoxClose=()=>{
    setOpenAccessioning(false)
  
                var obj = {
                  branch_id: parseInt(localStorage.getItem('branch_id')),
                  date_start: from.toISOString(),
                  date_end: to.toISOString()
                }
                fetch("https://eviewer.fslabs.com.pk/4DACTION/Web_AccessionCallingUpInvoices", {
                  method: "POST",
                  body: JSON.stringify(obj)
                }).then(res => res.json()).then((response) => {
                  var the_items = []
                  response.map((items) => {
                    var obj1 = {
                      date: new Date(items.invoice_date).getDate() + "/" + (new Date(items.invoice_date).getMonth() + 1) + "/" + (new Date(items.invoice_date).getFullYear()),
                      mobile_no: items.mobile_no,
                      patient_name: items.patient_name,
                      branch_name:items.branch_name,
                      remarks: items.remarks,
                      invoice_no: items.invoice_no,
                      view: 
                        <Button variant="contained" style={{ backgroundColor: '#125892', color: 'white' }} disableElevation onClick={() => {
                          setInvoiceNo(items.invoice_no)
                          setOpenAccessioning(true)
                        }}>
                          <  ReceiptIcon />
                        </Button>
                     

                    }
                    the_items.push(obj1)
                  })
                  setRows(the_items)
                  setOrg_Rows(the_items)
                
                })
  }
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  useEffect(() => {
        {/* 25-nov-2025 all branches show in drop down option */}

        if(localStorage.getItem('branch_id')==0 || !localStorage.getItem('branch_name')){
          setBranch("All")
              //  localStorage.setItem('branch_id', 0)
              //  localStorage.setItem('branch_name', "1- MPL, All")
               }
    
               fetch("https://eviewer.fslabs.com.pk/4DACTION/BranchesLoadAllfromWebserver").then(res => res.json()).then((response) => {
                setBranches(response)
            })



    if (localStorage.getItem('user_id') == null || localStorage.getItem('user_id') == undefined) {
      localStorage.clear()
      window.location.href = "https://invoicing.fslabs.com.pk"
    }
    if (localStorage.getItem('org_branch_id') == null || localStorage.getItem('org_branch_id') == undefined) {
      localStorage.clear()
      window.location.href = "https://invoicing.fslabs.com.pklogin"
    }
    if(localStorage.getItem('branch_id')=="0"){
      alert("Please Select Branch!!")
      window.location.href="https://invoicing.fslabs.com.pk"
    }
    // 25-jan-2025
    var vSearchStr = {
      "User_ID": localStorage.getItem('user_id'),
      "Menu_Option": "Accession Update"
    }
    fetch("https://eviewer.fslabs.com.pk/4DACTION/WebCheckUserStatusActiveAccess", {
      method: "POST",
      'Content-Type': "application/json",
      body: JSON.stringify(vSearchStr)
    }).then(res => res.json()).then((res) => {
      // console.log(res)
      if (res[0].Option_Status != "Authorized") {
        
         alert("User Not Authorized !")
         window.location.href="https://invoicing.fslabs.com.pk"

        // localStorage.setItem("franchise","true")
      }
    
    })
    from.setHours(15)
    to.setHours(15)
    var obj = {
      branch_id: parseInt(localStorage.getItem('branch_id')),
      date_start: from.toISOString(),
      date_end: to.toISOString(),
       // 9-may-2025
      //  new add panel_id on 25-11-2025
       panel_id:localStorage.getItem('panel_code')

    }
    // fetch("https://eviewer.fslabs.com.pk/4DACTION/Web_AccessionCallingUpInvoices", {
      fetch("https://eviewer.fslabs.com.pk/4DACTION/web_accession_calls_all_br_api", {
      
    method: "POST",
      body: JSON.stringify(obj)
    }).then(res => res.json()).then((response) => {
      var the_items = []
      response.map((items) => {
        var obj1 = {
          date: new Date(items.invoice_date).getDate() + "/" + (new Date(items.invoice_date).getMonth() + 1) + "/" + (new Date(items.invoice_date).getFullYear()),
          mobile_no: items.mobile_no,
          patient_name: <b>{items.patient_name}</b>,
          branch_name:items.branch_name,
          remarks: items.remarks,
          invoice_no: items.invoice_no,
          view: 
            <Button variant="contained" style={{ backgroundColor: '#125892', color: 'white' }} disableElevation onClick={() => {
              setInvoiceNo(items.invoice_no)
              setOpenAccessioning(true)
            }}>
              <  ReceiptIcon />
            </Button>
        

        }
        the_items.push(obj1)
      })
      setRows(the_items)
    })

      {/* 25-nov-2025 all branches show in drop down option */}

      if (localStorage.getItem('org_branch_id') == '0') {
        fetch("https://eviewer.fslabs.com.pk/4DACTION/BranchesLoadAllfromWebserver").then(res => res.json()).then((response) => {
        // 27-jan-2025
          // setBranches(response)
          const allBranches = [{ 
            AllowExceptionCredit
            : 
            false,
            BranchID
            :0,
            BranchName
            : 
            "All",
            BranchNameDisplay
            : 
            "All",
            If_Franchise
            : 
            false,
            MobileNo
            : 
            "",
            MobileService
            : 
            0,
            Province
            : 
            "",
            RestrictsInvoiceUnpaid
            : 
            false,
                            }, ...response];
                            console.log("Branches")
                            console.log(allBranches)
                          setBranches(allBranches)
            var obj = {}
             obj[0]="All"
            response.map((item) => {
              console.log(item)
                obj[item.BranchID] = item.BranchName
            })
            console.log("obj")
            console.log(obj)
            setSelectBranch(obj)
            setBranch(localStorage.getItem('branch_id'))
            setBranchName(localStorage.getItem('branch_name'))
        })
    }
  setBranch("ALL")
  


  }, [])
  Date.prototype.hhmm = function () {
    var mm = this.getMinutes();
    var hh = this.getHours();

    return [
      (hh > 9 ? '' : '0') + hh,
      (mm > 9 ? '' : '0') + mm
    ].join(':');
  };

  Date.prototype.ddmmyyy = function () {
    var mm = this.getMonth() + 1; // getMonth() is zero-based
    var dd = this.getDate();

    return [
      (dd > 9 ? '' : '0') + dd,
      (mm > 9 ? '' : '0') + mm,
      this.getFullYear()
    ].join('/');
  };
  return (
    <>
      <Paper className={classes.root}>


        <GridContainer style={{
          padding: '1em'
        }}>
           <GridItem xs={6} sm={6} md={2} lg={2}>
            {/* 25-nov-2025 all branches show in drop down option */}

          {localStorage.getItem('org_branch_id') == '0'?
                        <FormControl variant="filled" className={classes.formControl} style={{ width: "12.5em", marginLeft:0,}} >
                            <InputLabel id="demo-simple-select-filled-label">Branch</InputLabel>
                            <Select
                                labelId="demo-simple-select-filled-label"
                                id="demo-simple-select-filled"
                                value={branch}
                                onChange={(e) => {
                                  console.log("Branch Change")
                                  console.log(e)

                                    var result = window.confirm('Are you Sure ?. Your want to change Branch?')
                                    if (result) {
                                        setBranch(e.target.value)
                                        console.log("e.target.value")
                                        // console.log(e.target)
                                        // localStorage.setItem('branch_id', e.target.value)
                                        // localStorage.setItem('branch_name', selectBranch[e.target.value])
                                        // window.location.reload()
                                        var obj = {
                                          branch_id: e.target.value,
                                          date_start: from.toISOString(),
                                          date_end: to.toISOString(),
                                          // 9-may-2025
                                          panel_id:localStorage.getItem('panel_code')
                                        }
                                        console.log(obj)
                                        // 24-11-2025 monday 
                                        fetch("https://eviewer.fslabs.com.pk/4DACTION/web_accession_calls_all_br_api", {
                                        // fetch("https://reports.mpl-labs.pk:8443/4DACTION/Web_AccessionCallingUpInvoices", {
                                          method: "POST",
                                          body: JSON.stringify(obj)
                                        }).then(res => res.json()).then((response) => {
                                          var the_items = []
                                          response.map((items) => {
                                            console.log("web_accession_calls_all_br_api",items)
                                            var obj1 = {
                                              date: new Date(items.invoice_date).getDate() + "/" + (new Date(items.invoice_date).getMonth() + 1) + "/" + (new Date(items.invoice_date).getFullYear()),
                                              mobile_no: items.mobile_no,
                                              patient_name: <b>{items.patient_name}</b>,
                                              remarks: items.remarks,
                                              invoice_no: items.invoice_no,
                                              branch_name:items.branch_name,
                                              view: 
                                                <Button variant="contained" style={{ backgroundColor: '#196c91', color: 'white' }} disableElevation onClick={() => {
                                                  setInvoiceNo(items.invoice_no)
                                                  setOpenAccessioning(true)
                                                }}>
                                                  <  ReceiptIcon />
                                                </Button>
                                            
                                    
                                            }
                                            the_items.push(obj1)
                                          })
                                          setRows(the_items)
                                        })
                                    }

                                }}
                            >
                                <MenuItem value={"0"} disabled>Select</MenuItem>
                                {
                                    branches?.map((item) => {
                                      console.log(item)
                                        return <MenuItem value={item.BranchID} key={item.BranchID}>{item.BranchName}</MenuItem>
                                    })
                                }
                            </Select>
                        </FormControl>
                        :<>
                       </>}

          </GridItem>

          <GridItem xs={6} sm={6} md={2} lg={2}>

            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <KeyboardDateTimePicker
                variant="inline"
                inputVariant="outlined"
                label="From"
                ampm={false}
                minDate={new Date().setMonth(new Date().getMonth() - 1)}
                format="dd/MM/yyyy"
                value={from}
                maxDate={to}
                InputAdornmentProps={{ position: "start" }}
                onChange={date => {
                  setFrom(date)
                }}
              />
            </MuiPickersUtilsProvider>
          </GridItem>


          <GridItem xs={6} sm={6} md={2} lg={2}>

            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <KeyboardDateTimePicker
                variant="inline"
                inputVariant="outlined"
                label="To"
                ampm={false}
                format="dd/MM/yyyy"
                maxDate={new Date()}
                value={to}
                minDate={from}
                InputAdornmentProps={{ position: "start" }}
                onChange={date => setTo(date)}
              />
            </MuiPickersUtilsProvider>

          </GridItem>
          <GridItem xs={6} sm={6} md={2} lg={2}>
             {/* 25-nov-2025 all branches show in drop down option */}
          {localStorage.getItem('org_branch_id') == '0'?
          <Button
          variant="contained"
          color="secondary"
          style={{ marginTop: "1em",
          backgroundColor:"#196c91"
           }}
          onClick={() => {
            from.setHours(15)
            to.setHours(15)
            var obj = {
              branch_id: parseInt( branch),
              date_start: from.toISOString(),
              date_end: to.toISOString(),
               // 9-may-2025
              panel_id:localStorage.getItem('panel_code')
            }
            console.log(obj)
            // fetch("https://eviewer.fslabs.com.pk/4DACTION/Web_AccessionCallingUpInvoices", {
              fetch("https://eviewer.fslabs.com.pk/4DACTION/web_accession_calls_all_br_api", {

              method: "POST",
              body: JSON.stringify(obj)
            }).then(res => res.json()).then((response) => {
              console.log(response)
              var the_items = []

              response.map((items) => {
                var obj1 = {
                  date: new Date(items.invoice_date).getDate() + "/" + (new Date(items.invoice_date).getMonth() + 1) + "/" + (new Date(items.invoice_date).getFullYear()),
                  mobile_no: items.mobile_no,
                  patient_name: items.patient_name,
                  branch_name:items.branch_name,
                  remarks: items.remarks,
                  invoice_no: items.invoice_no,
                  view: 
                    <Button variant="contained" style={{ backgroundColor: '#196c91', color: 'white' }} disableElevation onClick={() => {
                      setInvoiceNo(items.invoice_no)
                      setOpenAccessioning(true)
                    }}>
                      <  ReceiptIcon />
                    </Button>
                 

                }
                the_items.push(obj1)
              })
              setRows(the_items)
              setOrg_Rows(the_items)
            
              
            })
          }}
          className={classes.button}
        >
          Search
      </Button>
      :
            <Button
              variant="contained"
              color="secondary"
              style={{ marginTop: "1em",
              backgroundColor:"#196c91"

               }}
              onClick={() => {
                from.setHours(15)
                to.setHours(15)
                var obj = {
                 branch_id: parseInt(localStorage.getItem('branch_id')),
                  date_start: from.toISOString(),
                  date_end: to.toISOString(),
                   // 9-may-2025
                  panel_id:localStorage.getItem('panel_code')
                }
                console.log(obj)
                // fetch("https://eviewer.fslabs.com.pk/4DACTION/Web_AccessionCallingUpInvoices", {
                  fetch("https://eviewer.fslabs.com.pk/4DACTION/web_accession_calls_all_br_api", {

                  method: "POST",
                  body: JSON.stringify(obj)
                }).then(res => res.json()).then((response) => {
                  console.log("web_accession_calls_all_br_api",response)
                  var the_items = []
                  response.map((items) => {
                    var obj1 = {
                      date: new Date(items.invoice_date).getDate() + "/" + (new Date(items.invoice_date).getMonth() + 1) + "/" + (new Date(items.invoice_date).getFullYear()),
                      mobile_no: items.mobile_no,
                      patient_name: items.patient_name,
                      branch_name:items.branch_name,
                      remarks: items.remarks,
                      invoice_no: items.invoice_no,
                      view: 
                        <Button variant="contained" style={{ backgroundColor: '#196c91', color: 'white' }} disableElevation onClick={() => {
                          setInvoiceNo(items.invoice_no)
                          setOpenAccessioning(true)
                        }}>
                          <  ReceiptIcon />
                        </Button>
                     

                    }
                    the_items.push(obj1)
                  })
                  setRows(the_items)
                  setOrg_Rows(the_items)
                
                  
                })
              }}
              className={classes.button}
            >
              Search
          </Button>
}
            {/* <Button
              variant="contained"
              color="secondary"
              style={{ marginTop: "1em",
              backgroundColor:"#125892"

               }}
              onClick={() => {
                from.setHours(15)
                to.setHours(15)
                var obj = {
                  branch_id: parseInt(localStorage.getItem('branch_id')),
                  date_start: from.toISOString(),
                  date_end: to.toISOString()
                }
                fetch("https://eviewer.fslabs.com.pk/4DACTION/Web_AccessionCallingUpInvoices", {
                  method: "POST",
                  body: JSON.stringify(obj)
                }).then(res => res.json()).then((response) => {
                  var the_items = []
                  response.map((items) => {
                    var obj1 = {
                      date: new Date(items.invoice_date).getDate() + "/" + (new Date(items.invoice_date).getMonth() + 1) + "/" + (new Date(items.invoice_date).getFullYear()),
                      mobile_no: items.mobile_no,
                      patient_name: items.patient_name,
                      remarks: items.remarks,
                      invoice_no: items.invoice_no,
                      view: 
                        <Button variant="contained" style={{ backgroundColor: '#125892', color: 'white' }} disableElevation onClick={() => {
                          setInvoiceNo(items.invoice_no)
                          setOpenAccessioning(true)
                        }}>
                          <  ReceiptIcon />
                        </Button>
                     

                    }
                    the_items.push(obj1)
                  })
                  setRows(the_items)
                  setOrg_Rows(the_items)
                
                  
                })
              }}
              className={classes.button}
            >
              Search
          </Button> */}

          </GridItem>

        </GridContainer>


        <div align="right">
          <TextField id="standard-basic" label="Search"

            onChange={async (e) => {
              var lab_tests = []
              var text = e.target.value
              var data = await org_rows.map((item) => {



                if (item.name.toLowerCase().includes(text.toLowerCase())) {
                  lab_tests.push(item)
                  return

                }
                if (item.passport.toLowerCase().includes(text.toLowerCase())) {
                  lab_tests.push(item)
                  return

                }
                if (item.cnic.toLowerCase().includes(text.toLowerCase())) {
                  lab_tests.push(item)
                  return

                }
                if (item.id.toLowerCase().includes(text.toLowerCase())) {
                  lab_tests.push(item)
                  return

                }

                return item

              })
              Promise.all(data).then((item) => {

                setRows(lab_tests)

              })

            }}
          />
        </div>
        {loading ?
          <center>
            <ReactLoading type={'spinningBubbles'} color={'black'} height={'10em'} width={'10em'} />
          </center>
          :
          <>
            <TableContainer className={classes.container}>
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    {columns.map((column) => (
                      <TableCell
                        key={column.id}
                        align={column.align}
                        style={{ minWidth: column.minWidth,backgroundColor:"#125892",color:"white" }}
                      >
                        {column.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                    return (
                      <TableRow hover role="checkbox" tabIndex={-1} key={row.code + Math.random()} >
                        {columns.map((column) => {
                          const value = row[column.id];

                          return (
                            <>

                              <TableCell key={column.id} align={column.align}  >
                                {value}
                              </TableCell>

                            </>
                          );
                        })}
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[10, 25, 100]}
              component="div"
              count={rows.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onChangePage={handleChangePage}
              onChangeRowsPerPage={handleChangeRowsPerPage}
            />
          </>
        }


      </Paper>
      <Dialog
        classes={{
          root: classes.center,
          paper: classes.modal
        }}

        maxWidth={'xl'}
        fullWidth={true}
        open={OpenAccessioning}
        TransitionComponent={Transition}
        keepMounted

        onClose={() => {
          setOpenAccessioning(false)

        }}
        aria-labelledby="classic-modal-slide-title"
        aria-describedby="classic-modal-slide-description"
      >
        <DialogTitle
          id="classic-modal-slide-title"
          disableTypography
          className={classes.modalHeader}
        >

          <h2 className={classes.modalTitle}><b>Accessioning</b></h2>
        </DialogTitle>
        <DialogContent
          id="classic-modal-slide-description"
          className={classes.modalBody}
        >

          {OpenAccessioning ?
            <center>
              <Fragment key={"sqq"}>
              <Accessioning invoice_no={invoice_no} BoxClose={BoxClose} />
              </Fragment>
            </center> : null}

      
        </DialogContent>
        <DialogActions className={classes.modalFooter}>

          
        </DialogActions>
      </Dialog>


    </>
  );
}
